module.exports = __webpack_public_path__ + "static/img/invoice.2f802db.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/invoice.png
// module id = 69TF
// module chunks = 1